const isDevelopment = import.meta.env.MODE !== "production";

type LogLevel = "info" | "warn" | "error" | "log";

const createLogger = () => {
  const formatMessage = (
    level: LogLevel,
    message: string,
    ...args: any[]
  ): string => {
    const timestamp = new Date().toISOString();
    return `[${timestamp}] [${level.toUpperCase()}] ${message}`;
  };

  const log = (level: LogLevel, message: string, ...args: any[]): void => {
    if (!isDevelopment) return;

    const formattedMessage = formatMessage(level, message);

    console[level](formattedMessage, ...args);
  };

  return {
    info: (message: string, ...args: any[]) => log("info", message, ...args),
    warn: (message: string, ...args: any[]) => log("warn", message, ...args),
    error: (message: string, ...args: any[]) => log("error", message, ...args),
    log: (message: string, ...args: any[]) => log("log", message, ...args),
  };
};

const logger = createLogger();

export default logger;
